// DensityProvider — expone `density: 'desktop' | 'mobile'` derivado del
// ancho de ventana. Algunos componentes (Sidebar, Topbar de S1) cambian
// layout completo según density, no solo responsive Tailwind.
//
//   const { density } = useDensity();
//   if (density === 'mobile') return <MobileLayout />;

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Density = 'desktop' | 'mobile';

const DensityContext = createContext<Density>('desktop');

function read(): Density {
  if (typeof window === 'undefined') return 'desktop';
  return window.innerWidth < 768 ? 'mobile' : 'desktop';
}

export function DensityProvider({ children }: { children: ReactNode }) {
  const [density, setDensity] = useState<Density>(() => read());

  useEffect(() => {
    const onResize = () => setDensity(read());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return <DensityContext.Provider value={density}>{children}</DensityContext.Provider>;
}

export function useDensity(): { density: Density } {
  return { density: useContext(DensityContext) };
}
